export default "__VITE_ASSET__Ck80EExQ__"